var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "group-set",
        {
          attrs: {
            "group-name": _vm.$t("application-form.co-applicant"),
            multi: !_vm.editVisibility,
            source: _vm.currentApplication["co-applicants"],
            path: "[co-applicants]",
            "add-as-button": !_vm.editVisibility,
          },
          on: { duplicate: _vm.handleDuplicate },
        },
        _vm._l(_vm.coApplicants, function (coApplicant, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "row",
              attrs: { id: _vm._f("hashId")("co-applicants[" + index + "]") },
            },
            [
              index > 0
                ? _c(
                    "div",
                    { staticClass: "col-12 mb-4" },
                    [
                      _c("div", { staticClass: "row" }, [
                        index > 0
                          ? _c("div", { staticClass: "card card-separator" }, [
                              _c("div", { staticClass: "card-header px-5" }, [
                                _c(
                                  "div",
                                  { staticClass: "row align-items-end" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 d-flex justify-content-between align-items-center",
                                      },
                                      [
                                        _vm.hasFirstName(index)
                                          ? _c("div", [
                                              _c(
                                                "h2",
                                                {
                                                  staticClass:
                                                    "section-separator-title text-primary",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.coApplicantName(
                                                          index
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "section-separator-title mb-1",
                                                },
                                                [
                                                  _vm.getCoApplicantType(index)
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getCoApplicantType(
                                                              index
                                                            )
                                                          )
                                                        ),
                                                      ])
                                                    : _c("br"),
                                                ]
                                              ),
                                            ])
                                          : _c("div", [
                                              _c(
                                                "h2",
                                                {
                                                  staticClass:
                                                    "section-separator-title text-primary",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.ordinalIndex(index)
                                                      ) +
                                                      "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "application-form.co-applicant"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "h4",
                                                {
                                                  staticClass:
                                                    "section-separator-title mb-1",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "application.messages.applicationInfoWillAppear"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          [
                                            _c("inline-prompt", {
                                              ref: "prompt",
                                              refInFor: true,
                                              staticClass:
                                                "d-inline-block bold text-gray ml-2",
                                              attrs: {
                                                "action-type": "delete",
                                                "confirmation-text": _vm.$t(
                                                  "application.messages.allDataWillBeLost"
                                                ),
                                              },
                                              on: {
                                                accept: function ($event) {
                                                  return _vm.handleRemove(
                                                    index,
                                                    "['co-applicants']"
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("applicant", {
                        attrs: {
                          type: "co-applicants[" + index + "]",
                          "applicant-index": index + 1,
                          "edit-visibility": _vm.editVisibility,
                          "type-title": _vm.$t("application-form.coapplicant"),
                          "current-application": _vm.currentApplication,
                          "co-apps-page": true,
                          "replicate-address": false,
                          "application-id": _vm.applicationId,
                          "client-username": _vm.clientUsername,
                        },
                        on: {
                          save: _vm.handleSave,
                          "toggle-visibility": _vm.handleVisibility,
                        },
                      }),
                    ],
                    1
                  )
                : _vm.coApplicants.length === 1
                ? _c("div", { staticClass: "card mb-1" }, [
                    _c("div", { staticClass: "card-body px-5" }, [
                      _c("div", { staticClass: "row align-items-center" }, [
                        _c("div", { staticClass: "col-auto" }, [
                          _c("img", {
                            staticClass: "img-fluid rounded-circle lg",
                            attrs: {
                              src: require("@Shared/@Assets/img/user-male-placeholder.png"),
                              alt: _vm.$t("global.words.profilePhoto"),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "h4",
                            {
                              staticClass:
                                "regular text-light-gray align-middle my-auto",
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t(
                                      "application.messages.onlyOneCoapplicant"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }